import React, { useState } from 'react';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { cart, getTotal } = useCart();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsCartOpen(false); // Ferme le panier si le menu est ouvert
  };
  
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
    setIsMenuOpen(false); // Ferme le menu si le panier est ouvert
  };

  return (
    <>
      {/* Overlay de flou */}
      {(isMenuOpen || isCartOpen) && (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={() => {
          setIsMenuOpen(false);
          setIsCartOpen(false);
        }} />
      )}

      <nav className="fixed w-full bg-white/80 backdrop-blur-md z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <a href="/" className="flex items-center space-x-2">
                <img src="/images/logo_détouré2.png" alt="Logo" className="h-12 w-auto" />
                
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-800 hover:text-mdm-pink transition-colors font-fredoka">Accueil</a>
              <a href="/store" className="text-gray-800 hover:text-mdm-pink transition-colors font-fredoka">Store</a>
              <button
                onClick={toggleCart}
                className="text-gray-800 hover:text-mdm-pink transition-colors relative"
              >
                <ShoppingCart className="w-6 h-6" />
                {cart.length > 0 && (
                  <span className="absolute -top-2 -right-2 bg-mdm-pink text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-fredoka">
                    {cart.length}
                  </span>
                )}
              </button>
            </div>

            {/* Mobile menu buttons */}
            <div className="md:hidden flex items-center space-x-4">
              <button
                onClick={toggleCart}
                className="text-gray-800 hover:text-mdm-pink transition-colors relative"
              >
                <ShoppingCart className="w-6 h-6" />
                {cart.length > 0 && (
                  <span className="absolute -top-2 -right-2 bg-mdm-pink text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-fredoka">
                    {cart.length}
                  </span>
                )}
              </button>
              <button
                onClick={toggleMenu}
                className="text-gray-800 hover:text-mdm-pink transition-colors"
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden absolute w-full bg-white shadow-lg">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="/" className="block px-3 py-2 text-gray-800 hover:text-mdm-pink font-fredoka">Accueil</a>
              <a href="/store" className="block px-3 py-2 text-gray-800 hover:text-mdm-pink font-fredoka">Store</a>
            </div>
          </div>
        )}

        {/* Cart Preview */}
        {isCartOpen && (
          <div className="absolute right-0 mt-2 w-[calc(100%-2rem)] md:w-96 mx-4 md:mr-4 bg-white rounded-lg shadow-xl p-4">
            <h3 className="text-lg font-fredoka font-semibold mb-4 text-mdm-pink">Panier</h3>
            {cart.length === 0 ? (
              <p className="text-gray-500 font-fredoka">Votre panier est vide</p>
            ) : (
              <>
                <div className="space-y-4">
                  {cart.map((item) => (
                    <div key={item.product.id} className="flex justify-between items-center font-fredoka">
                      <span>{item.product.name}</span>
                      <span>{item.quantity} x {item.product.price}€</span>
                    </div>
                  ))}
                </div>
                <div className="mt-4 pt-4 border-t">
                  <div className="flex justify-between font-fredoka font-semibold">
                    <span>Total</span>
                    <span>{getTotal()}€</span>
                  </div>
                  <a
                    href="/cart"
                    className="mt-4 w-full bg-mdm-pink text-white py-2 px-4 rounded-lg text-center hover:bg-mdm-blue transition-colors font-fredoka"
                  >
                    Voir le panier
                  </a>
                </div>
              </>
            )}
          </div>
        )}
      </nav>
    </>
  );
}